import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { UserRightService } from '../../../Model/UserRight/user-right.service';
import { Router } from '@angular/router';
import { SessionService } from '../../../Util/Session/session.service';
import { CommonService } from '../../../Model/Common/common.service';

@Component({
  selector: 'app-back-report',
  standalone: true,
  imports: [LoaderComponent,CommonModule],
  templateUrl: './back-report.component.html',
  styleUrl: './back-report.component.scss'
})
export class BackReportComponent {
  isDisabled: boolean = false;
  menus = [] as any;
  user = [] as any
  constructor(
    private userright: UserRightService,
    private router: Router,
    private session: SessionService,
    private common: CommonService,
  ) {
    this.user = this.session.GetUserDetails();
  }

  ngOnInit() {
    this.ESS_ProfileMenuRightsView();
  }

  ESS_ProfileMenuRightsView() {
    this.userright.ESS_ProfileMenuRightsView({ SelectType: 'View' }).subscribe({
      next: (response) => {
        try {
          this.menus = response.filter((e:any) => e.ESS_MenuMasterId == 58)[0].SubMenus.filter((e:any) => e.ESS_MenuMasterId == 60)[0];
          // const submenu = this.menus.SubMenus.find((e: any) => e.MenuLabel == 'Attendance Reports')
          // submenu.SubMenus.push({
          //   AddApplicable: false,
          //   DeleteApplicable: false,
          //   ESS_MenuMasterId: 62,
          //   EditApplicable: false,
          //   Icon: "aschedule.png",
          //   IsActive: true,
          //   IsExternal: false,
          //   IsNewTab: false,
          //   MenuLabel: "Employee Duration Report",
          //   MenuLevel: 4,
          //   MenuOrder: 1,
          //   MenuParentId: 61,
          //   PrintApplicable: true,
          //   ProfileMasterID: 1,
          //   ProfileName: "SUPER ADMINISTRATOR",
          //   SubMenus: [],
          //   URL: "reports/report/view/b/15",
          // })
        } catch (e) { this.menus = [] }

        //this.router.url
      },
      complete: () => { },
      error: (error) => { },
    });
  }

  ReportPage(menuid: number, url: String) {
    console.log(menuid);
    console.log(url);
    this.common.selectedmenuID = menuid
    // this.user.selectedmenuID = menuid;
    // this.session.Start(this.user);
    this.router.navigate([url]);
  }

  navigateToCommonReport() {
    this.router.navigate(['/reports/report/view', 'b', 15]);
  }
}
